import React, { useEffect, useState } from 'react'
import DetalleDeCarga from './DetalleDeCarga'
import { connect } from 'react-redux'
import { obtenerDetalleDeCarga } from '../../actions/TablaCargaBuquesActions'
import { COLORES } from '../../../../config/colores'
import { makeStyles } from '@material-ui/core'
import AltaDetalleCarga from './AltaDetalleCarga'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'

const useStyles = makeStyles((theme) => ({
  containerData: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  labelData: {
    color: COLORES.grey.dark,
    padding: '12px',
    border: '1px solid',
    borderColor: COLORES.grey.dark,
    borderRadius: '22px',
    margin: 0
  }
}))

function CargaDeBuque (props) {
  const { data, detalleCarga, obtenerDetalleDeCarga } = props
  const [toneladasTotal, setToneladasTotal] = useState(data.toneladasTotal || 0)
  const classes = useStyles()

  useEffect(() => {
    if (data && data.fechaAnuncio) {
      obtenerDetalleDeCarga(data.fechaAnuncio)
    }
  }, [data, obtenerDetalleDeCarga])

  useEffect(() => {
    let total = 0
    detalleCarga && detalleCarga.map((d) => {
      total = total + d.toneladas
      return total
    })
    setToneladasTotal(total)
  }, [detalleCarga, setToneladasTotal])

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      {data && (data.nombre || data.toneladasTotal)
        ? <div className={classes.containerData}>
          {data.nombre
            ? <h5 className={classes.labelData}>
                                Buque: <b>{data.nombre}</b>
            </h5>
            : null
          }
          {toneladasTotal > 0
            ? <h5 className={classes.labelData}>
                                Toneladas total: <b>{toneladasTotal}</b>
            </h5> : null
          }
        </div>
        : null

      }

      <AltaDetalleCarga fechaAnuncio={data && data.fechaAnuncio} showAdd={detalleCarga && detalleCarga.length === 0} />
      { detalleCarga && detalleCarga.length > 0 && <DetalleDeCarga /> }

    </>
  )
}

const mapStateToProps = (state) => ({
  detalleCarga: state.buque.detalleCarga
})

const mapActionsToProps = {
  obtenerDetalleDeCarga
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(CargaDeBuque)
